import { useFormContext } from '@ariakit/react'

import { FormError } from '../../../../../../app/_components/form/FormError'
import { VariantSelectionInvisibleInput } from '../../../../../../app/_components/forms/VariantSelectionForm'
import { usePortal } from '../../../../../../app/_providers/PortalProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../../containers/EmbroideryService/EmbroideryService'
import { DetailsSectionSidePaddedSection } from '../../styles'

export const embroiderySectionFormFieldName = 'embroiderySection' as const

export const EmbroiderySectionFormError = ({
  isPortalColorSelected,
  categoryAnalyticsId,
}: {
  isPortalColorSelected: boolean
  categoryAnalyticsId: string
}) => {
  const translations = useTranslation()
  const formContext = useFormContext()
  const { selectedEmbroideryFormOptions, confirmAddEmbroidery, embroideryOptions } =
    EmbroideryService.useContainer()
  const { hasMandatoryTextEmbroidery, hasMandatoryLogoEmbroidery } = usePortal()

  const mandatoryTextEmbroidery = hasMandatoryTextEmbroidery({
    categoryAnalyticsId,
  })
  const mandatoryLogoEmbroidery = hasMandatoryLogoEmbroidery({
    categoryAnalyticsId,
  })

  const isProductEmbroiderable = embroideryOptions.length > 0

  // Determine if portal embroidery is defined as required
  const isTextEmbroideryRequired =
    isPortalColorSelected && isProductEmbroiderable && mandatoryTextEmbroidery

  const isLogoEmbroideryRequired =
    isPortalColorSelected && isProductEmbroiderable && mandatoryLogoEmbroidery

  // Determine if selected embroidery items are valid for what is defined by the portal
  const isMissingRequiredTextEmbroidery =
    isTextEmbroideryRequired &&
    (!selectedEmbroideryFormOptions?.textFirstLine || !confirmAddEmbroidery)

  const mustConfirmTextEmbroidery = isTextEmbroideryRequired && !confirmAddEmbroidery

  const isMissingRequiredLogoEmbroidery =
    isLogoEmbroideryRequired && !selectedEmbroideryFormOptions?.logoImageSource

  formContext!.useValidate(() => {
    if (isMissingRequiredTextEmbroidery) {
      formContext!.setError(
        embroiderySectionFormFieldName,
        translations.embroidery.validation.textEmbroideryRequired
      )
    } else if (isMissingRequiredLogoEmbroidery) {
      formContext!.setError(
        embroiderySectionFormFieldName,
        translations.embroidery.validation.logoEmbroideryRequired
      )
    } else if (mustConfirmTextEmbroidery) {
      formContext!.setError(
        embroiderySectionFormFieldName,
        translations.embroidery.validation.textEmbroideryConfirmationRequired ??
          translations.embroidery.validation.textEmbroideryRequired
      )
    }
  })

  if (
    !isMissingRequiredTextEmbroidery &&
    !isMissingRequiredLogoEmbroidery &&
    !mustConfirmTextEmbroidery &&
    formContext?.getFieldTouched(embroiderySectionFormFieldName)
  ) {
    formContext!.setFieldTouched(embroiderySectionFormFieldName, false)
  }

  return (
    <DetailsSectionSidePaddedSection>
      <VariantSelectionInvisibleInput
        aria-hidden='true'
        tabIndex={-1}
        name={embroiderySectionFormFieldName}
      />
      <FormError name={embroiderySectionFormFieldName} />
    </DetailsSectionSidePaddedSection>
  )
}
